// A titled, collapsible block inside the extraction panel. The chrome lives here
// so the panel's sections (Text, Facts, Extraction details) stay visually identical.
import { useState } from "react";
import { Chevron } from "./Chevron";

interface Props {
  title: string;
  defaultExpanded?: boolean;
  // Right-aligned in the header; its clicks don't reach the toggle.
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}

export const CollapsibleSection = ({
  title,
  defaultExpanded = true,
  headerRight,
  children,
}: Props): JSX.Element => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <div style={{ borderBottom: "1px solid #e5e7eb" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 12px",
          background: "#f9fafb",
        }}
      >
        <button
          type="button"
          onClick={() => setExpanded((e) => !e)}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            fontSize: 13,
            fontWeight: 600,
            color: "#111827",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          <Chevron tree open={expanded} /> {title}
        </button>
        {headerRight ? (
          <span
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            role="presentation"
          >
            {headerRight}
          </span>
        ) : null}
      </div>
      {expanded ? children : null}
    </div>
  );
};

export default CollapsibleSection;
